import styled from 'styled-components/macro';
 
export const Wrapper = styled.div`
  a {
    display: inline-flex;
    gap: 2px;
    text-decoration: none;
  }
`;

export const Text = styled.span`
  color: #0063fb;
  font-weight: 600;
`;
